import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export function useMyAccess() {
  return useQuery({
    queryKey: ['myAccess'],
    queryFn: async () => {
      const { data } = await api.get('/api/my-access');
      return data;
    },
  });
}
